export const replaceAtIndex = (arr, el, i) => [
  ...arr.slice(0, i),
  el,
  ...arr.slice(i + 1),
];
